import { render, staticRenderFns } from "./FaceRecognition.vue?vue&type=template&id=24c427e2&scoped=true"
import script from "./FaceRecognition.vue?vue&type=script&lang=js"
export * from "./FaceRecognition.vue?vue&type=script&lang=js"
import style0 from "./FaceRecognition.vue?vue&type=style&index=0&id=24c427e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c427e2",
  null
  
)

export default component.exports